<template lang="pug">
  .panel-page
    .panel.mx-auto.body-1
      PageHeader Help

      h4.mt-4.mb-3 Frequently Asked Questions
      Expander.mb-2(
        v-for="(faq, idx) in faqs"
        :heading="faq[0]"
        :key="faq[0]"
        :show.sync="show[idx]"
      ) {{ faq[1] }}

      .row
        .col
          h4.mt-4.mb-3 User Guide
        .col
          h4.mt-4.mb-3 Contact Us
      .row
        .col.contact-form
          p
            img.guide-icon(src="../assets/img/user_guide.svg")
            br
            a(href="https://prod-static-content.methcheck.hc.appriss.com/nplexle/manual.pdf" target="_blank") Download User Guide (PDF)
          p.training-video
            img.guide-icon(src="../assets/img/video.svg")
            br
            a(href="https://prod-static-content.methcheck.hc.appriss.com/nplexle/training.mp4" target="_blank") Watch Training Video (MP4)
        .col.contact-form
          form(@submit.prevent="submitContact")
            .form-group
              label(for="contact-name" required) Name
              input#contact-name.form-control(
                v-model="contactName"
                :class="{'is-invalid': contactNameInvalid}")
              FormError(v-if="contactNameInvalid") Name is required.
            .form-group
              label(for="contact-email" required) Email Address
              input#contact-email.form-control(
                v-model="contactEmail"
                :class="{'is-invalid': contactEmailInvalid}")
              FormError(v-if="contactEmailInvalid") Email is required.
              FormError(v-if="contactEmailIfInvalid") {{ stdmsg.emailError }}
            .form-group
              label(for="contact-phone") Phone Number
              input#contact-phone.form-control(v-model="contactPhone")
            .form-group
              label(for="inquiry-reason" required) Reason for Inquiry
              select.form-control(
                v-model="contactReason"
                :class="{'is-invalid': contactReasonInvalid}"
              )
                option Update Account Information
                option Error Message
                option Data Question
                option Update My Agency
                option How do I …
                option Watch Hit Question
                option Testimonial/Success Story
                option Enhancement Request
              FormError(v-if="contactReasonInvalid") Reason for Inquiry is required.
            .form-group
              label(for="inquiry-description" required) Inquiry Description
              textarea#inquiry-reason.form-control(
                v-model="contactDescription"
                :class="{'is-invalid': contactDescriptionInvalid}"
              )
              FormError(v-if="contactDescriptionInvalid") Description is required.
            .form-group
              label(for="cc-list") CC
              textarea#cc-list.form-control(v-model="contactCcList")
              small.form-text.text-muted One address per line.
            button.btn.btn-primary Submit
</template>

<script>
import PageHeader from '@/components/PageHeader'
import Expander from '@/components/Expander'
import faqs from '@/lib/faqs'
import axios from '@/lib/axios'
import stdmsg from '@/lib/stdmsg'
import { globalError, globalSuccess } from '@/lib/utils'
import { mapRequiredIf } from '@/lib/validation'

export default {
  name: 'Help',
  data() {
    return {
      faqs,
      stdmsg,
      show: faqs.map(() => false),
      contactName: '',
      contactEmail: '',
      contactPhone: '',
      contactReason: '',
      contactDescription: '',
      contactCcList: '',
      contactFormSubmitted: false,
    }
  },
  computed: {
    contactReasonInvalid() {
      return !this.contactReason && this.contactFormSubmitted
    },
    contactDescriptionInvalid() {
      return !this.contactDescription && this.contactFormSubmitted
    },
    contactNameInvalid() {
      return !this.contactName && this.contactFormSubmitted
    },
    contactEmailInvalid() {
      return !this.contactEmail && this.contactFormSubmitted
    },
    contactEmailTouched() {
      return this.contactFormSubmitted
    },
    ...mapRequiredIf(['contactEmail'], x => /[^@]+@.+\..+/.test(x)),
  },
  methods: {
    submitContact() {
      this.contactFormSubmitted = true
      if (
        this.contactReasonInvalid ||
        this.contactDescriptionInvalid ||
        this.contactNameInvalid ||
        this.contactEmailInvalid ||
        this.contactEmailIfInvalid
      )
        return
      axios()
        .post('/api/misc/notify_support', {
          contactName: this.contactName,
          contactEmail: this.contactEmail,
          contactPhone: this.contactPhone,
          contactReason: this.contactReason,
          contactDescription: this.contactDescription,
          contactCcList: this.contactCcList,
        })
        .then(() => {
          globalSuccess(null, 'The support request has been submitted.')
          scrollTo(0, 0)
          this.clearForm()
          this.contactFormSubmitted = false
        })
        .catch(err => {
          globalError(err)
          scrollTo(0, 0)
        })
    },
    clearForm() {
      this.contactName = ''
      this.contactEmail = ''
      this.contactPhone = ''
      this.contactReason = ''
      this.contactDescription = ''
      this.contactCcList = ''
    },
  },
  components: { PageHeader, Expander },
}
</script>

<style lang="scss" scoped>
.panel {
  width: 1007px;
  border: none;
}

.contact-form {
  border: 1px solid #d8d8d8;
  // margin-left: 1rem;
  margin: 0.3rem;
  padding: 1rem;
}

.training-video {
  max-width: inherit;
}

.guide-icon {
  max-width: 10%;
}
</style>
